/**
 * Cart drawer product recommendations ("You may also like").
 * Fetches Shopify's native product recommendations (complementary, falling
 * back to related/same-category) for whatever product was most recently
 * added to the cart, and injects them into #CartDrawerRecommendations
 * inside the cart drawer.
 *
 * Important: cart.items is NOT reliably ordered "most recently added last"
 * (observed order on this store: newest first), so we do not infer the
 * active product from array position. Instead we intercept every
 * /cart/add.js call (both the theme's native Add to Cart button and our own
 * quick-add buttons) and read the product id directly out of that
 * response, persisting it in sessionStorage so it survives the cart
 * drawer's section-HTML swaps and page navigations within the session.
 */
(function () {
  var STORAGE_KEY = 'tmhCartRecsLastAddedProductId';
  var cartAddUrl = (window.routes && window.routes.cartAddUrl) || '/cart/add.js';

  function rememberProductId(id) {
    if (!id) return;
    try {
      sessionStorage.setItem(STORAGE_KEY, String(id));
    } catch (e) {}
  }

  function recalledProductId() {
    try {
      return sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  // Intercept fetch-based add-to-cart calls (native theme button + ours)
  // so we always know the product id of whatever was just added, instead
  // of guessing from cart.items order.
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;

    var result = nativeFetch.apply(this, arguments);

    if (isAdd) {
      result.then(function (response) {
        response
          .clone()
          .json()
          .then(function (data) {
            if (data && data.product_id) {
              rememberProductId(data.product_id);
            } else if (data && data.items && data.items.length) {
              rememberProductId(data.items[data.items.length - 1].product_id);
            }
          })
          .catch(function () {});
      });
    }

    return result;
  };

  function getRecommendationsUrl(productId, intent) {
    var base = (window.routes && window.routes.productRecommendationsUrl) || '/recommendations/products';
    return base + '?section_id=cart-drawer-recommendations&product_id=' + encodeURIComponent(productId) + '&limit=6&intent=' + intent;
  }

  function fetchRecommendations(productId) {
    return nativeFetch(getRecommendationsUrl(productId, 'complementary'))
      .then(function (response) { return response.text(); })
      .then(function (html) {
        if (html && html.indexOf('CartRecommendations__Item') !== -1) {
          return html;
        }
        return nativeFetch(getRecommendationsUrl(productId, 'related')).then(function (response) {
          return response.text();
        });
      });
  }

  function loadCartRecommendations() {
    var container = document.getElementById('CartDrawerRecommendations');
    if (!container) return;

    // Prefer the product id of whatever was actually just added to the
    // cart this session; fall back to the server-rendered guess (last item
    // in cart.items) only for a cold page load where nothing has been
    // added yet.
    var productId = recalledProductId() || container.getAttribute('data-product-id');

    if (!productId) {
      container.innerHTML = '';
      container.removeAttribute('data-loaded-for');
      return;
    }

    if (container.getAttribute('data-loaded-for') === productId) return;

    fetchRecommendations(productId)
      .then(function (html) {
        var current = document.getElementById('CartDrawerRecommendations');
        if (!current) return;
        current.innerHTML = html;
        current.setAttribute('data-loaded-for', productId);
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', loadCartRecommendations);
  document.addEventListener('cart:refresh', loadCartRecommendations);
  document.addEventListener('cart:updated', loadCartRecommendations);

  // Covers AJAX cart drawer re-renders (section HTML swaps) that don't
  // dispatch a cart:refresh event. Observing document.body rather than the
  // drawer node itself survives the drawer element being replaced wholesale.
  var observer = new MutationObserver(function () {
    loadCartRecommendations();
  });

  document.addEventListener('DOMContentLoaded', function () {
    observer.observe(document.body, { childList: true, subtree: true });
  });

  // Quick-add from the recommendations strip.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cart-recommendation-add]');
    if (!button) return;

    event.preventDefault();
    if (button.disabled) return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = '...';

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data && data.status) {
          // Shopify returns a 4xx body with a status/description on failure
          // (e.g. sold out between page load and click).
          button.textContent = 'Sold out';
          setTimeout(function () {
            button.textContent = originalText;
            button.disabled = false;
          }, 1500);
          return;
        }

        button.textContent = 'Added';
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        setTimeout(function () {
          button.textContent = originalText;
          button.disabled = false;
        }, 1200);
      })
      .catch(function () {
        button.textContent = originalText;
        button.disabled = false;
      });
  });
})();
